/* eslint no-param-reassign: "off", no-console: "off" */
import NotificationStore from './notifications/notification-store';
import LoaderStore from './loader/loader-store';
import FavoriteStore from './favorites/favorites-store';

const systemStore = {
  state: {
    globalNotificationActive: false,
    contextPane: null,
    detailPane: false,
    settings: {},
    // these two properties are used by the table settings flyout
    activeTableColumns: [],
    activeTablePageSize: 25,
    activeTableVisibleColumns: [],
    activeTableContext: null,
    activeTableReorderedColumns: []
  },
  mutations: {
    updateGlobalNotificationState(state, payload) {
      state.globalNotificationActive = payload;
    },
    setContextPane(state, payload) {
      if (payload == state.contextPane) {
        state.contextPane = null;
      } else {
        state.contextPane = payload;
      }
    },
    setDetailPane(state, payload) {
      state.detailPane = payload;
    },
    // When loading a list page, the table's columns are stored via this commit
    setActiveTableProperties(state, payload) {
      state.activeTableColumns = payload.columns || [];
      state.activeTablePageSize = payload.pageSize || 25;
      state.activeTableVisibleColumns = payload.visibleColumns || [];
      state.activeTableContext = payload.table || null;
      state.activeTableReorderedColumns = payload.reorderedColumns || [];
    },
    updateActiveTableVisibleColumns(state, payload) {
      state.activeTableVisibleColumns = payload;
    },
    updateActiveTablePageSize(state, payload) {
      state.activeTablePageSize = payload;
    },
    updateActiveTableReorderedColumns(state, payload) {
      state.activeTableReorderedColumns = payload;
    }
  },
  actions: {
    // eslint-disable-next-line no-empty-pattern
    async submitFeedback({}, payload) {
      try {
        const res = await fetch('/v2/feed/feedback', {
          body: JSON.stringify(payload),
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' })
        });
        return res.ok;
      } catch (ex) {
        console.error(ex);
        return false;
      }
    }
  },
  getters: {

  },
  modules: {
    notifications: NotificationStore,
    loader: LoaderStore,
    favorites: FavoriteStore
  }
}
export default systemStore;
